import { dbApi, getApiErrorMessage } from "@/lib/api"

export async function requestPasswordReset(
  email: string
): Promise<{ ok: true; message: string } | { ok: false; error: string }> {
  try {
    const { data } = await dbApi.post<{ message: string }>(
      "/api/auth/forgot-password",
      { email }
    )
    return { ok: true, message: data.message }
  } catch (e) {
    return { ok: false, error: getApiErrorMessage(e) }
  }
}

export async function resetPassword(
  token: string,
  password: string
): Promise<{ ok: true; message: string } | { ok: false; error: string }> {
  try {
    const { data } = await dbApi.post<{ message: string }>(
      "/api/auth/reset-password",
      { token, password }
    )
    return { ok: true, message: data.message }
  } catch (e) {
    return { ok: false, error: getApiErrorMessage(e) }
  }
}
